import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// Interfaces
import type { Album } from '../../interfaces/albums';
import type { Artist } from '../../interfaces/artist';
import type { Playlist } from '../../interfaces/playlists';
import type { Track } from '../../interfaces/track';
import type { RadioStation } from '../../interfaces/radio';

type Item = Playlist | Album | Track | Artist | RadioStation;

const initialState: {
  items: Item[];
} = {
  items: [],
};

const searchHistoryActionsSlice = createSlice({
  name: 'searchHistory',
  initialState,
  reducers: {
    setItem(state, action: PayloadAction<Item>) {
      if (!action.payload || !action.payload.id) return;
      state.items = [
        action.payload,
        ...state.items.filter((item) => item.id !== action.payload.id),
      ].slice(0, 30);
    },
    clearItems(state) {
      state.items = [];
    },
    removeItem(state, action: PayloadAction<Item>) {
      state.items = state.items.filter((item) => item.id !== action.payload.id);
    },
  },
});

export const searchHistoryActions = {
  ...searchHistoryActionsSlice.actions,
};

export default searchHistoryActionsSlice.reducer;
